import { useState, useRef, useEffect } from 'react';

const useAudioPlayer = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [audioSources, setAudioSources] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const play = () => {
    if (audioRef.current) {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  const pause = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const stop = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
      setAudioSources([])
      setCurrentIndex(0)
    }
  };

  const next = () => {
    if (currentIndex < audioSources.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      stop(); // Optionally, stop playback if at the end of the list
    }
  };

  const previous = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const togglePlayPause = () => {
    if (isPlaying) {
      pause();
    } else {
      play();
    }
  };

  useEffect(() => {
    if (audioRef.current && audioSources.length) {
      audioRef.current.src = audioSources[currentIndex].audioFilePath;
      play();
    }
  }, [currentIndex, audioSources]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.addEventListener('ended', next);
      return () => {
        audioRef.current && audioRef.current.removeEventListener('ended', next);
      };
    }
  }, [currentIndex, next]);

  return {
    audioRef,
    isPlaying,
    play,
    pause,
    stop,
    // next,
    // previous,
    setAudioSources,
    // togglePlayPause,
    audioSources
  };
};

export default useAudioPlayer;
